import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { supabase, getUsersByRole } from '../supabase.config'
import Topbar from '../components/Layout/Topbar'
import { Sidebar } from '../components/Layout/Sidebar'
import EditWarehouseform from '../components/ManageWarehouse/EditWarehouseform'

const EditWarehouse = () => {
	const [editWarehouse, setEditWarehouse] = useState(false)
	const navigate = useNavigate()
	const [warehouseDetails, setwarehouseDetails] = useState({})
	const { id } = useParams()
	const handleeditWarehouseModal = () => {
		setEditWarehouse(!editWarehouse)
	}
	const [userList, setuserList] = useState([])
	const [pickupName, setPickupName] = useState({})
	const [warehouseData, setWarehouseData] = useState({
		pinCode: "",
		city: "",
		state: "",
		country: "",
		address: "",
		personName: "",
		email: "",
		phone: "",
		slot: ""
	})
	
	const fetchwarehouseDetails = async () => {
		const { data, error } = await supabase
			.from('warehouses')
			.select('*')
			.eq('id', id)
			.single()
		
		if (error) {
			console.error('Failed to fetch warehouse:', error)
			alert('Failed to load warehouse details: ' + error.message)
			return
		}
		
		if (!data) {
			alert('Warehouse not found')
			navigate("/warehouse")
			return
		}
		
		setwarehouseDetails(data)
		
		// Map Supabase data to UI format
		// If warehouse has a user_id, try to fetch user details, otherwise use warehouse name
		if (data.user_id) {
			const { data: userData } = await supabase
				.from('users')
				.select('id, name, email, company_name')
				.eq('id', data.user_id)
				.single()
			
			if (userData) {
				setPickupName({
					id: userData.id,
					name: userData.name || '',
					email: userData.email || '',
					companyName: userData.company_name || '',
					uid: userData.id
				})
			} else {
				// User not found, use warehouse name
				setPickupName({
					id: data.user_id,
					name: data.name || '',
					companyName: data.company_name || '',
					uid: data.user_id
				})
			}
		} else {
			// No user_id, use warehouse name as pickup name
			setPickupName({
				name: data.name || '',
				companyName: data.company_name || '',
			})
		}
		
		setWarehouseData({
			pinCode: data.pin_code || "",
			city: data.city || "",
			state: data.state || "",
			country: data.country || "",
			address: data.address || "",
			personName: data.contact_person || "",
			email: "", // Email not stored in Supabase schema
			phone: data.contact_number || "",
			slot: data.preferred_slot || "",
		})
	}
	
	const UpdateWarehouse = async () => {
		// Validation
		if (!pickupName || (!pickupName.name && !pickupName.companyName)) {
			alert("Please enter the PickUp Name")
			return
		}
		if (warehouseData.pinCode.length === 0) {
			alert("Please enter the Pin Code")
			return
		}
		if (warehouseData.city.length === 0) {
			alert("Please enter the City name")
			return
		}
		if (warehouseData.state.length === 0) {
			alert("Please enter the State name")
			return
		}
		if (warehouseData.country.length === 0) {
			alert("Please enter the Country name")
			return
		}
		if (warehouseData.address.length === 0) {
			alert("Please enter the Address")
			return
		}
		if (warehouseData.personName.length === 0) {
			alert("Please enter the Person name")
			return
		}
		if (warehouseData.phone.length === 0) {
			alert("Please enter the Phone Number")
			return
		}
		if (warehouseData.slot.length === 0) {
			alert("Please enter the Slot")
			return
		}
		
		// Map UI data to Supabase schema
		const name = pickupName?.name || pickupName?.companyName || 'Warehouse'
		const payload = {
			name,
			company_name: pickupName?.companyName || '',
			pin_code: warehouseData.pinCode,
			city: warehouseData.city,
			state: warehouseData.state,
			country: warehouseData.country,
			address: warehouseData.address,
			contact_person: warehouseData.personName,
			contact_number: warehouseData.phone,
			preferred_slot: warehouseData.slot,
			status: 'active',
		}
		
		// Only set user_id if pickupName has an id
		if (pickupName?.id || pickupName?.uid) {
			payload.user_id = pickupName.id || pickupName.uid
		}
		
		const { error } = await supabase
			.from('warehouses')
			.update(payload)
			.eq('id', id)
		
		if (error) {
			console.error('Failed to update warehouse:', error)
			alert('Failed to update warehouse: ' + error.message)
			return
		}
		
		navigate("/warehouse")
	}
	
	const fetchUsers = async () => {
		const { data, error } = await getUsersByRole('client', 'logistics')
		if (error) {
			console.error('Failed to fetch users for autocomplete', error)
			return
		}
		const users = (data || []).map(u => ({
			id: u.id,
			name: u.name,
			email: u.email,
			companyName: u.company_name,
			uid: u.id
		}))
		setuserList(users)
	}

	useEffect(() => {
		fetchwarehouseDetails()
		fetchUsers()
	}, [id])

	return (
		<div className='bg-gray-100 flex '>
			<Sidebar />
			<div className='h-[100vh]  flex flex-1 flex-col'>
				<Topbar />
				<EditWarehouseform userList={userList} pickupName={pickupName} setPickupName={setPickupName} UpdateWarehouse={UpdateWarehouse} warehouseData={warehouseData} setWarehouseData={setWarehouseData} setEditWarehouse={setEditWarehouse} />
			</div>
		</div>
	)
}

export default EditWarehouse